import { render, staticRenderFns } from "./TimeslotCollectionConfig.vue?vue&type=template&id=5c7a4772&"
import script from "./TimeslotCollectionConfig.vue?vue&type=script&lang=js&"
export * from "./TimeslotCollectionConfig.vue?vue&type=script&lang=js&"
import style0 from "./TimeslotCollectionConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports